import {
  DoorStickerTemplate,
  FlyerTemplate,
  PolygraphyProductType,
  StickerTemplate,
} from '../../../../../../../services/exports/Constants';

export default {
  title: 'Productos de impresión',
  types: {
    [PolygraphyProductType.Flyer]: {
      name: 'Flyers',
      templates: {
        [FlyerTemplate.One]: '#1 🆕',
        [FlyerTemplate.Two]: '#2  🆕',
        [FlyerTemplate.Three]: '#3',
        [FlyerTemplate.Four]: '#4',
      },
    },
    [PolygraphyProductType.Sticker]: {
      name: 'Pegatinas',
      templates: {
        [StickerTemplate.One]: '#1 🆕',
      },
    },
    [PolygraphyProductType.DoorSticker]: {
      name: 'Pegatinas de puerta',
      templates: {
        [DoorStickerTemplate.One]: '#1 🆕',
        [DoorStickerTemplate.Two]: '#2 🆕',
      },
    },
    [PolygraphyProductType.Custom]: {
      name: 'Productos de impresión personalizados',
    },
  },
  buttons: {
    order: 'Nuevo pedido',
  },
  toasts: {
    failed_to_load_data: 'Error al cargar los datos',
  },
};
